export const MIN_AMOUNT = 300
